export const API_BASE_URL =

 // "http://localhost:8001/api/v1/";
  "https://api.andamanmakeholidays.com/api/v1/";



export const API_PATHS = {

  login: "admin/admin-login",

  //places
  getplace: "admin/places/fetch",
  addplace: "admin/places/add",
  editplace: "admin/places/edit",
  deleteplace: "admin/places/delete",

  //category
  gettravelCategory: "admin/travelCategory/fetch",
  addtravelCategory: "admin/travelCategory/add",
  edittravelCategory: "admin/travelCategory/edit",
  deletetravelCategory: "admin/travelCategory/delete",


  //tour package
  gettravelPackage: "admin/travelPackage/fetch",
  addtravelPackage: "admin/travelPackage/add",
  edittravelPackage: "admin/travelPackage/edit",
  deletetravelPackage: "admin/travelPackage/delete",

  //amenity
  getamenity: "admin/amenity/fetch",
  addamenity: "admin/amenity/add",
  editamenity: "admin/amenity/edit",
  deleteamenity: "admin/amenity/delete",


  //bed type
  getbedtype: "admin/bedType/fetch",
  addbedtype: "admin/bedType/add",
  editbedtype: "admin/bedType/edit",
  deletebedtype: "admin/bedType/delete",

  //property type
  getpropertytype: "admin/propertyType/fetch",
  addpropertytype: "admin/propertyType/add",
  editpropertytype: "admin/propertyType/edit",
  deletepropertytype: "admin/propertyType/delete",


  //ferry services
  getferryservice: "admin/ferry/fetch",
  addferryservice: "admin/ferry/add",
  editferryservice: "admin/ferry/edit",
  deleteferryservice: "admin/ferry/delete",

  //hotel admin
  addhotelAdmin: "admin/hotelAdmin/add",
  gethotelAdmin: "admin/hotelAdmin/fetch",
  edithotelAdmin: "admin/hotelAdmin/edit",

  //hotels for admin
  gethotel: "admin/hotel/fetch",
  edithotel: "admin/hotel/edit",

  //file upload
  uploadFile: "admin/upload",


  //hoteladmin apis

  //hotels
  addHotels: "hotel-admin/hotel/add",
  getHotels: "hotel-admin/hotel/fetch",
  editHotels: "hotel-admin/hotel/edit",

  //room types
  addRoomType: "admin/roomType/add",
  getRoomType: "admin/roomType/fetch",
  editRoomType: "admin/roomType/edit",

  //rooms

  addRoom: "hotel-admin/room/add",
  getRoom: "hotel-admin/room/fetch",
  editRoom: "hotel-admin/room/edit",

  //availability
  addAvailability: "hotel-admin/roomDates/add",
  getAvailability: "hotel-admin/roomDates/fetch",
  editAvailability: "hotel-admin/roomDates/edit",

  //tour package
  getcarrentalPackage: "admin/carrentalPackage/fetch",
  addcarrentalPackage: "admin/carrentalPackage/add",
  editcarrentalPackage: "admin/carrentalPackage/edit",
  deletecarrentalPackage: "admin/carrentalPackage/delete",

  //enquiry
  getEnquiry: "admin/enquiry/fetch",
  editEnquiry: "admin/enquiry/edit",


  //car type
  addCarType:"admin/car/add",
  editCarType:"admin/car/edit",
  getCarType:"admin/car/fetch",
  getCarTypeRange:"admin/car/fetch/range",
  deleteCarType:"admin/car/delete",


  //airport car rental
  addairportCarCharges:"admin/airportCarCharges/add",
  editairportCarCharges:"admin/airportCarCharges/edit",
  getairportCarCharges:"admin/airportCarCharges/fetch",
  deleteairportCarCharges:"admin/airportCarCharges/delete",

    //hourly car rental
    addhourlyCarCharges:"admin/hourlyCarCharges/add",
    edithourlyCarCharges:"admin/hourlyCarCharges/edit",
    gethourlyCarCharges:"admin/hourlyCarCharges/fetch",
    deletehourlyCarCharges:"admin/hourlyCarCharges/delete",



    //placewise hotel
    addplacewiseHotel:"admin/placewiseHotel/add",
    editplacewiseHotel:"admin/placewiseHotel/edit",
    getplacewiseHotel:"admin/placewiseHotel/fetch",
    deleteplacewiseHotel:"admin/placewiseHotel/delete",


     //pickupdrop
     addpickupdropCharges:"admin/pickupdrop/add",
     editpickupdropCharges:"admin/pickupdrop/edit",
     getpickupdropCharges:"admin/pickupdrop/fetch",
     deletepickupdropCharges:"admin/pickupdrop/delete",

        //water sports
        addwaterSports:"admin/waterSports/add",
        editwaterSports:"admin/waterSports/edit",
        getwaterSports:"admin/waterSports/fetch",
        deletewaterSports:"admin/waterSports/delete",

       

}